import { render, staticRenderFns } from "./TaxInvoiceNiksOnRoll.vue?vue&type=template&id=95dec07c&scoped=true&"
import script from "./TaxInvoiceNiksOnRoll.vue?vue&type=script&lang=js&"
export * from "./TaxInvoiceNiksOnRoll.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=95dec07c&scoped=true&lang=css&"
import style1 from "./TaxInvoiceNiksOnRoll.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./TaxInvoiceNiksOnRoll.vue?vue&type=style&index=2&id=95dec07c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dec07c",
  null
  
)

export default component.exports